const NEWS_TIP_REQUIRED_FIELDS = ['title', 'location', 'content']

export { NEWS_TIP_REQUIRED_FIELDS }
export default NEWS_TIP_REQUIRED_FIELDS
